import { render, staticRenderFns } from "./ListInboundIntegrations.vue?vue&type=template&id=7f621dfc&scoped=true&"
import script from "./ListInboundIntegrations.vue?vue&type=script&lang=js&"
export * from "./ListInboundIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./ListInboundIntegrations.vue?vue&type=style&index=0&id=7f621dfc&scoped=true&lang=scss&"
import style1 from "./ListInboundIntegrations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f621dfc",
  null
  
)

export default component.exports